

import logo from '../../assets/logoEasyTT.png';



import AppBase from '../appBase';

import React from "react";
class App2 extends AppBase
{

  
    
    constructor (props)
    {
        super(props);
        console.log("Init Application")
        
    }  

    canClose()
    {
      return true;
    }


    componentDidMount() {
      // Contexte disponible après le montage du composant
      
    }

  render ()
  {
    return (
      <div className="App">
        
        <header className="App-header">
          <h1 style={{Color:"white"}}>PROJETS EN LOCAL</h1>
          <img src={logo} className="App-logo" alt="logo" />
          <p>
            En construction, ça avance encore et encore...<br/>C'est que le début, d'accord, d'accord...
            <br/>
            Current Language: {this.context.language}

            

          </p>
        </header>
      </div>
      )
    }
}

export default App2;
